import './breadchannel.scss'
export default function breadProgress($stateParams, $state) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      entry: '=',
      parentId: '@',
    },
    templateUrl: 'app/components/breadChannel/breadChannel.html',
    link: breadProgressLink,
  }

  return directive

  function breadProgressLink($scope, $element, $attr) {
    $scope.items = [
      {
        step: '1',
        name: 'Details',
        className: 'todo',
        disable: false,
      },
      {
        step: '2',
        name: 'Sets',
        className: 'todo',
        disable: false,
      },
      {
        step: '3',
        name: 'Bundles',
        className: 'todo',
        disable: false,
      },
      {
        step: '4',
        name: 'Top Prizes',
        className: 'todo',
        disable: false,
      },
      {
        step: '5',
        name: 'Games',
        className: 'todo',
        disable: false,
      },
    ]

    if ($attr.entry === 'Details') {
      $scope.items[0].className = 'active'
    } else if ($attr.entry === 'Sets') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'active'
    } else if ($attr.entry === 'Bundles') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'active'
    } else if ($attr.entry === 'TopPrizes') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'todo'
      $scope.items[2].step = ''
      $scope.items[3].className = 'active'
    } else if ($attr.entry === 'Games') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'todo'
      $scope.items[2].step = ''
      $scope.items[3].className = 'todo'
      $scope.items[3].step = ''
      $scope.items[4].className = 'active'
    }

    $scope.link = function (item) {
      let id = undefined
      if ($stateParams.id) {
        id = $stateParams.id
      } else if ($stateParams.channelId) {
        id = $stateParams.channelId
      } else {
        id = $stateParams.parentId
      }

      switch (item.name) {
        case 'Details':
          $state.go('pub.channels.edit', {
            id: id,
          })
          break
        case 'Sets':
          $state.go('pub.channels.sets', {
            parentId: id,
          })
          break
        case 'Bundles':
          $state.go('pub.bundles', {
            parentId: 0,
            channelId: id,
          })
          break
        case 'Top Prizes':
          $state.go('pub.channels.top_prizes', {
            parentId: id,
          })
          break
        case 'Games':
          $state.go('pub.games', { channelId: id })
          break
      }
    }
  }
}
